(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    // 1. Funzione per aprire Shopify Inbox
    function openShopifyInbox() {
      const host = document.querySelector('inbox-online-store-chat');
      if (!host || !host.shadowRoot) return false;
      const btn = host.shadowRoot.querySelector('button');
      if (btn) { btn.click(); return true; }
      return false;
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('#open-chat-btn');
      if (!trigger) return;
      event.preventDefault();
      if (openShopifyInbox()) return;
      let tries = 0;
      const t = setInterval(() => {
        if (openShopifyInbox() || ++tries >= 10) clearInterval(t);
      }, 200);
    });

    // 2. LOGICA DINAMICA AVANZATA (MutationObserver)
    function handleSoldOutButtons() {
      const form = document.querySelector('product-form-component');
      if (!form) return;

      const atcButton = form.querySelector('[name="add"]');
      const contactPlaceholder = document.querySelector('[data-contact-placeholder]');
      
      if (!atcButton || !contactPlaceholder) return;

      // Funzione che decide se mostrare o nascondere
      const updateVisibility = () => {
        if (atcButton.hasAttribute('disabled') || atcButton.disabled) {
          contactPlaceholder.classList.remove('hidden');
        } else {
          contactPlaceholder.classList.add('hidden');
        }
      };

      // Eseguiamo un controllo immediato al caricamento
      updateVisibility();

      // Osserviamo il bottone: se cambia l'attributo 'disabled', aggiorniamo i contatti
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'disabled') {
            updateVisibility();
          }
        });
      });

      observer.observe(atcButton, { attributes: true });
    }

    // Inizializza la logica
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleSoldOutButtons);
    } else {
      handleSoldOutButtons();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
